import { render, staticRenderFns } from "./TeamMemberCustomFields.vue?vue&type=template&id=5ed3f431&"
import script from "./TeamMemberCustomFields.vue?vue&type=script&lang=js&"
export * from "./TeamMemberCustomFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ed3f431')) {
      api.createRecord('5ed3f431', component.options)
    } else {
      api.reload('5ed3f431', component.options)
    }
    module.hot.accept("./TeamMemberCustomFields.vue?vue&type=template&id=5ed3f431&", function () {
      api.rerender('5ed3f431', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TeamMemberCustomFields.vue"
export default component.exports